import { ReceiptPercentIcon, UserIcon } from "@heroicons/react/20/solid";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const EnrolmentRequired = ({
	reEnrolment,
}) => {
	return (
		<div
			className="block text-center bg-white"
			style={{ paddingTop: 120 }}
		>
			<div id="all-done">
				<div
					className="item item-circle bg-primary"
					style={{ position: "relative", height: "12rem", width: "12rem" }}
				>
					<UserIcon
						style={{ position: "absolute", height: "10rem", color: "white", right: "1rem", top: "1rem" }}
					/>
					<ReceiptPercentIcon
						style={{
							position: "absolute",
							height: "5rem",
							color: "#ea611c",
							right: "0rem",
							top: "6rem",
							background: "white",
							borderRadius: "5rem",
							padding: "0.5rem",
						}}
					/>
				</div>
				<div className="main">
					<h1 className="font-w700 text-center">Pension Auto {reEnrolment ? `Re-Enrolment`: `Enrolment`}</h1>
					{
						reEnrolment ?
						<h4 className="text-center">It seems your cyclical re-enrolment is overdue.</h4>
						:
						<h4 className="text-center">It seems that you still need to review your employees' pensions.</h4>
					}
					<p className="text-center">
						Under the Pensions Act 2008, every employer in the UK must put certain staff into a workplace
						pension scheme and contribute towards it.
					</p>
					<p className="text-center">
						{
							reEnrolment ?
							<Link to="/re-enrolment">Complete Re-Enrolment</Link>
							:
							<Link to="/notifications">Review Enrolment</Link>
						}
					</p>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(EnrolmentRequired);
